<template>
<div>
  <div id="qyyxEdit" v-if="editFlag">
      <div id="kpxxView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="xqyxForm" :model="xqyxForm" label-width="0px" label-position="right" :rules="qyyxRules">
          <el-row class="tr mb5">
            <el-col :span="8">
              <span class="mr5 vbm yxLabel">Exhibit type</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="reserve1" style="text-align: left">
                <el-select size="small" v-model="xqyxForm.reserve1" class="searchSelect" clearable placeholder="All" @change="changeReserve1(xqyxForm.reserve1)">
                  <el-option v-for="item in czlxData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">Type of Booth</span>
            </el-col>
            <el-col :span="8">
              <!-- <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="All">
                  <el-option v-for="item in zwlxData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
              </el-select> -->
              <el-form-item prop="zwlx" style="text-align: left" v-if="xqyxForm.reserve1=='01'">
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="All">
                    <el-option v-for="item in zwlxDataCL" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="zwlx" style="text-align: left" v-else-if="xqyxForm.reserve1 =='02'|| xqyxForm.reserve1 =='03'">
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="All">
                    <el-option v-for="item in zwlxDataZBandJZ" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="zwlx" style="text-align: left" v-else>
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="All">
                    <el-option v-for="item in zwlxData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="2" style="text-align: left">
              
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '1'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">Standard Booth(9m² Each)</span>
            </el-col>
            <el-col :span="8">
              <!-- <el-input-number size="small" v-model="xqyxForm.bzzwgs" :min="0" :max="4" :precision="0" placeholder="Standard Booth"></el-input-number> -->
              <el-form-item prop="bzzwgs">
                <el-input size="small" v-model="xqyxForm.bzzwgs" placeholder="Standard Booth" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;Booth(s)</span>
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '2'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">Indoor Raw Space Booth(Minimum 2 Booth(s), 18m²)</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="sngdzw">
                <!-- <el-input-number size="small" v-model="xqyxForm.sngdzw" :min="0" :max="1000" :precision="0" placeholder="Indoor Raw Space Booth"></el-input-number> -->
                <el-input size="small" v-model="xqyxForm.sngdzw" placeholder="Indoor Raw Space Booth" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;Booth(s)</span>
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '3'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">Outdoor Raw Space Booth(Minimum 11 Booth(s), 99m²,Only Available to
                <span style="color: red">Elevating Fire Trucks</span>)</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="swgdzw">
                <!-- <el-input-number size="small" v-model="xqyxForm.swgdzw" :min="0" :max="1500" :precision="0" placeholder="Outdoor Raw Space Booth"></el-input-number> -->
                <el-input size="small" v-model="xqyxForm.swgdzw" placeholder="Outdoor Raw Space Booth" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;Booth(s)</span>
            </el-col>
          </el-row>

        <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;margin-top:50px">
          <el-col :span="24">
            <strong style="color: #2452ff;">Booth selection History</strong>
          </el-col>
        </el-row>
          <el-row class="mb5" style="line-height: 29px;margin-top:30px;text-align: center;" >
            
          </el-row>
          <el-row style="text-align: center;">
            <div>
              <el-col :span="6">&nbsp;</el-col>
              <el-col :span="6"  v-for="(domain, index) in hisData" :key="index">
                <el-row class="mb10">
                  <strong>{{domain.zhjs}}th Standard Booth：</strong>
                  <span v-text="domain.bzzwgs==null?'no':domain.bzzwgs+' Booth(s)'"></span>
                </el-row>
                <el-row class="mb10">
                  <strong>{{domain.zhjs}}th Raw Space Booth：</strong>
                  <span v-text="domain.gdzwmj==null?'no':domain.gdzwmj+' m²'"></span>
                </el-row>
              </el-col>
              <el-col v-if="this.hisData.length == 0">
                <span>No History</span>
              </el-col>
            </div>
          </el-row>

          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="zwyxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">Cancel</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitXqyx('xqyxForm')">Save</el-button>
            </el-col>
          </el-row>
        </el-form>

        
      </div>
  </div>

  <div class="main-container" element-loading-text="loading" v-if="!editFlag">
    <div id="qyzwyx" class="mb20">
        <el-row >
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <el-form class="el-form demo-form-inline" ref="xqyxForm" :model="xqyxForm" label-width="150px" label-position="right">
            <el-row class="mb10">
              <strong>Exhibit type：</strong>
              <span  v-text="zwyxData.code_NAME_ENG"></span>
            </el-row>
            <el-row class="mb10" v-if="xqyxForm.zwlx == '1'">
              <strong>Standard Booth：</strong>
             
              <span v-text="(xqyxForm.bzzwgs==''||xqyxForm.bzzwgs==null)?'no':xqyxForm.bzzwgs+' Booth(s)'"></span>
              &nbsp;&nbsp;(9m² Each)
            </el-row>
            <el-row class="mb10" v-if="xqyxForm.zwlx == '2'">
              <strong>Indoor Raw Space Booth：</strong>
              <span v-text="(xqyxForm.sngdzw==''||xqyxForm.sngdzw==null)?'no':xqyxForm.sngdzw+' Booth(s)'"></span>
              &nbsp;&nbsp;(Minimum 2 Booth(s), 18m²)
            </el-row>
            <el-row class="mb10" v-if="xqyxForm.zwlx == '3'">
              <strong>Outdoor Raw Space Booth：</strong>

              <span v-text="(xqyxForm.swgdzw==''||xqyxForm.swgdzw==null)?'no':xqyxForm.swgdzw+' Booth(s)'"></span>
              &nbsp;&nbsp;(Minimum 11 Booth(s), 99m²,Only Available to
                <span style="color: red">Elevating Fire Trucks</span>)
            </el-row>
            </el-form>
          </el-col>
           <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">Edit</el-button>
            </el-col>
        </el-row>
      </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  
  name: "qyyxEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //需求意向表单
      xqyxForm: {
        reserve1:"",
        zwlx:"",
      },
      //需求意向uuid
      xqUuid: "",
      xqyxStatus:0,
      czlxData:[],
      qyyxRules:{
        reserve1: [
          { required: true, message: "Exhibit type is required", trigger: "change" }
        ],
        zwlx: [
          { required: true, message: "Type of Booth is required", trigger: "change" }
        ],
        bzzwgs:[
          // { required: true, message: "Standard Booth is required", trigger: "blur" },
          // {
          //   pattern: /^([1-4])$/,
          //   message: "Please fill in an integer from 1 to 4",
          //   trigger: "blur"
          // }
        ],
        sngdzw:[
           { required: true, message: "Indoor Raw Space Booth is required", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "Please fill in an integer",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let v = this.xqyxForm.sngdzw;
              if (v != null && v != '' && v<2) {
                callback(new Error("Indoor Raw Space Booth quantity should be 2-166 (18-1494m²)"));
              } else if (v != null && v != '' && v>166) {
                callback(new Error("Indoor Raw Space Booth quantity should be 2-166 (18-1494m²)"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
        swgdzw:[
          { required: true, message: "Outdoor Raw Space Booth is required", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "Please fill in an integer",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let v = this.xqyxForm.swgdzw;
              if (v != null && v != '' && v<11) {
                callback(new Error("Outdoor Raw Space Booth quantity should be 11-166 (99-1494m²)"));
              } else if (v != null && v != '' && v>166) {
                callback(new Error("Outdoor Raw Space Booth quantity should be 11-166 (99-1494m²)"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
      },
      //历史数据
      hisData:[],

      zwyxData: [],
      editFlag: false,
      zwlxData:[],
      zwlxDataCL:[],
      zwlxDataZBandJZ:[],
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findXqyxByQyid(this.qyid);
        this.getZwHis(this.qyid);
      }
    }
  },
  created: function() {
    this.getCzlxData(); 
    //this.findXqyxByQyid(this.qyid);
    //this.getZwHis(this.qyid);
    this.getZwlxData();
  },
  methods: {
    getZwlxData: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/ZWLX_ENG").then(
        function(res) {
          vm.zwlxData = res.data.result;
          for(let i in res.data.result){
            if(res.data.result[i].codeValue != '1'){
              vm.zwlxDataCL.push(res.data.result[i]);
            }
            if(res.data.result[i].codeValue != '3'){
              vm.zwlxDataZBandJZ.push(res.data.result[i]);
            }
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    getCzlxData: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/CZLX_ENG").then(
        function(res) {
          vm.czlxData = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //通过企业id查找企业参展展位需求意向
    findXqyxByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qyzwyx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            this.zwyxData = JSON.parse(JSON.stringify(res.data.result[0]));

            vm.xqyxStatus = 1; //修改
            //返回null时不自动带入min值
            if (res.data.result[0].bzzwgs != null)
              vm.xqyxForm.bzzwgs = res.data.result[0].bzzwgs;
            if (res.data.result[0].sngdzw != null)
              vm.xqyxForm.sngdzw = String(Math.round(Number(res.data.result[0].sngdzw) / 9));
            if (res.data.result[0].swgdzw != null)
              vm.xqyxForm.swgdzw = String(Math.round(Number(res.data.result[0].swgdzw) / 9));
            
            vm.xqyxForm.reserve1 = res.data.result[0].reserve1;
            vm.xqyxForm.zwlx = res.data.result[0].zwlx;
            vm.xqUuid = res.data.result[0].uuid;

            this.changeRules(vm.xqyxForm.reserve1);

            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }
          } else {
            vm.xqyxStatus = 0; //新增
            vm.editFlag = true;
          }
          vm.$emit("getLoading", false);
        }.bind(vm),
        function(error) {
          vm.$emit("getLoading", false);
          console.log(error);
        }
      );
    },
    //需求意向提交
    submitXqyx: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("Failed to save. Please fill in the Brief Information before filling in other information", 'Info', {
          confirmButtonText: 'ok'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          let n = (vm.xqyxForm.bzzwgs > 0)+(vm.xqyxForm.sngdzw > 0)+(vm.xqyxForm.swgdzw > 0);
          
          if(n==0){
            vm.$alert('Please choose one kind of booth!', 'warning', {
              confirmButtonText: 'OK',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          }
          // else if(n>1){
          //   vm.$alert('Only one kind of booth can be selected!', 'warning', {
          //     confirmButtonText: 'OK',
          //     type: 'warning'
          //   });
          //   console.log("error submit!!");
          //   return false;
          // }
          if(vm.xqyxForm.zwlx == '1' && (vm.xqyxForm.bzzwgs > 4 || vm.xqyxForm.bzzwgs < 1 )){
            vm.$alert(' Please fill in 1-4 Standard Booths', '提示', {
              confirmButtonText: 'OK',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          }
          else{
            vm.$emit("getLoading", true);
            if (vm.xqyxStatus == 0) {
              //新增
              var params = {
                qyid: vm.qyid,
                bzzwgs: vm.xqyxForm.bzzwgs,
                sngdzw: (vm.xqyxForm.sngdzw != null && vm.xqyxForm.sngdzw !== '') ? String(Number(vm.xqyxForm.sngdzw) * 9) : '',
                swgdzw: (vm.xqyxForm.swgdzw != null && vm.xqyxForm.swgdzw !== '') ? String(Number(vm.xqyxForm.swgdzw) * 9) : '',
                deleteFlag: "N",
                cjrid: vm.currentUser.userid,
                cjrmc: vm.currentUser.username,
                reserve1: vm.xqyxForm.reserve1,
                validateFlag: 'T',
                zwlx: vm.xqyxForm.zwlx
              };
              vm.$axios.post("/qyzwyx/doInsertXqyxByVO", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                    vm.$message({
                      message: "Questionnaire on your Booth Requirement has been saved!",
                      type: "success"
                    });
                    vm.xqUuid = res.data.result.uuid;
                    vm.$emit("getLoading", false);
                    //this.$emit("getActive",  6);
                    vm.editFlag = false;
                    vm.findXqyxByQyid(this.qyid);

                    vm.xqyxStatus = 1;
                    //vm.submit();
                  } else {
                    vm.$message({
                      message: "Questionnaire on your Booth Requirement save failed",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            } else {
              //修改
              var params = {
                uuid: vm.xqUuid,
                qyid: vm.qyid,
                bzzwgs: vm.xqyxForm.bzzwgs,
                sngdzw: (vm.xqyxForm.sngdzw != null && vm.xqyxForm.sngdzw !== '') ? String(Number(vm.xqyxForm.sngdzw) * 9) : '',
                swgdzw: (vm.xqyxForm.swgdzw != null && vm.xqyxForm.swgdzw !== '') ? String(Number(vm.xqyxForm.swgdzw) * 9) : '',
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.username,
                reserve1: vm.xqyxForm.reserve1,
                validateFlag: 'T',
                zwlx: vm.xqyxForm.zwlx
              };
              vm.$axios.post("/qyzwyx/doUpdateByVO", params).then(
                function(res) {
                  if (res.data.result > 0) {
                    vm.$message({
                      message: "Questionnaire on your Booth Requirement has been saved!",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                    //this.$emit("getActive",  6);

                    vm.editFlag = false;
                    vm.findXqyxByQyid(this.qyid);
                    //提交展位预报名信息
                    //vm.submit();
                  } else {
                    vm.$message({
                      message: "Questionnaire on your Booth Requirement save failed",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            }
          } 
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
      }
    },
    //提交
    submit: function() {
      if (this.currentUser.deptid == "ZSYH") {
        //如果是展商用户跳转到确认页
        this.$router.push({
          name: "exhpredictionConfirm",
          query: { userid: this.currentUser.userid, type: "BJ" }
        });
      } else {
        //如果是管理员跳转到列表页
        this.$router.push({ name: "exhprediction" });
      }
    },
    //需求意向上一步
    cancelXqyx: function() {
      this.$emit("getActive",  4);
    },
    //获取历史展位选择情况
    getZwHis: function(qyid){
      let vm = this;
      let params={
        qyid: qyid,
        zhjs: window.config.zhjs
      }
      vm.$axios.post('/zwjbxxHis/doSearchHisListByVO' ,params).then(function (res) {
        if(res.data.code = '00000000') {
              this.hisData = res.data.result;
        }
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findXqyxByQyid(this.qyid);
    },
    changeReserve1: function(czlx){
      this.xqyxForm.zwlx="";
      this.changeRules(czlx);
      
    },
    changeRules(czlx){
      switch(czlx){
        case '01':
          this.qyyxRules.sngdzw=[
            { required: true, message: "Indoor Raw Space Booth is required", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "Please fill in an integer",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<7) {
                  callback(new Error("Vehicle & large equipment Indoor Raw Space Booth quantity should be 7-166 (63-1494m²)"));
                } else if (v != null && v != '' && v>166) {
                  callback(new Error("Vehicle & large equipment Indoor Raw Space Booth quantity should be 7-166 (63-1494m²)"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
        case '02':
          this.qyyxRules.sngdzw=[
            { required: true, message: "Indoor Raw Space Booth is required", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "Please fill in an integer",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<2) {
                  callback(new Error("Indoor Raw Space Booth quantity should be 2-44 (18-396m²)"));
                } else if (v != null && v != '' && v>44) {
                  callback(new Error("Indoor Raw Space Booth quantity should be 2-44 (18-396m²)"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
        case '03':
          this.qyyxRules.sngdzw=[
            { required: true, message: "Indoor Raw Space Booth is required", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "Please fill in an integer",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<2) {
                  callback(new Error("Indoor Raw Space Booth quantity should be 2-44 (18-396m²)"));
                } else if (v != null && v != '' && v>44) {
                  callback(new Error("Indoor Raw Space Booth quantity should be 2-44 (18-396m²)"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
      }
    }
  }
};
</script>

<style lang="scss">
#qyyxEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Xqyx.vue